import { combineReducers, configureStore } from "@reduxjs/toolkit"
import {
   persistStore,
   persistReducer,
   FLUSH,
   REHYDRATE,
   PAUSE,
   PERSIST,
   PURGE,
   REGISTER,
} from "redux-persist"
import storage from "redux-persist/lib/storage"
import userReducer from "./userRedux"
import productReducer from "./productRedux"
import orderReducer from "./orderRedux"
import shopReducer from "./shopRedux"
import pageContentReducer from "./pageContentRedux"
import imageReducer from "./imageRedux"
import emailReducer from "./emailRedux"
import serviceReducer from "./serviceRequestRedux"

const persistConfig = {
   key: "root",
   version: 1,
   storage,
}

const rootReducer = combineReducers({
   user: userReducer,
   product: productReducer,
   order: orderReducer,
   shop: shopReducer,
   pageContent: pageContentReducer,
   image: imageReducer,
   email: emailReducer,
   service: serviceReducer,
})
const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
   reducer: persistedReducer,
   middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
         serializableCheck: {
            ignoreActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
         },
      }),
})

export const persistor = persistStore(store)
